module.exports = __webpack_public_path__ + "static/media/APP_Ranger_152x174_1-06.d3ac9c99.png";